const c = {
  "stock-price": "stock-price",
  "stock-price__heading": "stock-price__heading",
  "stock-price__price": "stock-price__price",
  "stock-price__value": "stock-price__value",
  "stock-price__currency": "stock-price__currency",
  "stock-price__unavailable": "stock-price__unavailable",
  "stock-price__daily-change": "stock-price__daily-change",
  "stock-price__difference": "stock-price__difference",
  "stock-price__relative-difference": "stock-price__relative-difference",
  "stock-price__price-difference": "stock-price__price-difference",
  "stock-price__icon": "stock-price__icon",
  "stock-price__icon--down": "stock-price__icon--down",
  "stock-price__icon--equal": "stock-price__icon--equal",
  "stock-price__icon--up": "stock-price__icon--up"
};
export {
  c as default
};
